export interface Town {
    name: string
    area: string
    county: string
}

export const TOWNS: Town[] = [
    { name: "Albertville", area: 'marshall-county', county: "Marshall County" },
    { name: "Ardmore", area: 'limestone-county', county: "Limestone County" },
    { name: "Athens", area: 'limestone-county', county: "Limestone County" },
    { name: "Courtland", area: 'morgan-county', county: "Lawrence County" },
    { name: "Decatur", area: 'morgan-county', county: "Morgan County" },
    { name: "Elkmont", area: 'limestone-county', county: "Limestone County" },
    { name: "Florence", area: 'lauderdale-county', county: "Lauderdale County" },
    { name: "Guntersville", area: 'marshall-county', county: "Marshall County" },
    { name: "Gurley", area: 'madison-county', county: "Madison County" },
    { name: "Harvest", area: 'harvest', county: "Madison County" },
    { name: "Hazel Green", area: 'madison-county', county: "Madison County" },
    { name: "Hillsboro", area: 'morgan-county', county: "Lawrence County" },
    { name: "Huntsville", area: 'huntsville', county: "Madison County" },
    { name: "Killen", area: 'lauderdale-county', county: "Lauderdale County" },
    { name: "Madison", area: 'madison', county: "Madison County" },
    { name: "Meridianville", area: 'madison-county', county: "Madison County" },
    { name: "New Market", area: 'madison-county', county: "Madison County" },
    { name: "Owens Cross Roads", area: 'madison-county', county: "Madison County" },
    { name: "Scottsboro", area: 'jackson-county', county: "Jackson County" },
    { name: "Tanner", area: 'limestone-county', county: "Limestone County" },
    { name: "Town Creek", area: 'morgan-county', county: "Lawrence County" }
]

export const COUNTIES = [
    "Madison County",
    "Limestone County",
    "Morgan County",
    "Lawrence County",
    "Lauderdale County",
    "Jackson County",
    "Marshall County"
]

export const townsForArea = (area: string): Town[] => TOWNS.filter(town => town.area === area)

export const areaForTown = (name: string): string | undefined => {
    const normalized = name.trim().toLowerCase()

    return TOWNS.find(town => town.name.toLowerCase() === normalized)?.area
}
